import React from 'react';
import TopNav from '../components/TopNav';
import { Link, useHistory } from 'react-router-dom';
import { FaArrowLeft } from "react-icons/fa";

import BottomNav from '../components/BottomNav';

const TermsCondition = () => {
  const history = useHistory();

  return (
    <div>
      <div className="nav-section">
        <TopNav pageChannel="T&C" />
      </div>
      <div className="w-100 terms-page">
        <div className="link-back">
          <Link
            to={{
              pathname: '/',
              state: {
                pageChannel: 'T&C',
              },
            }}
          >
            <FaArrowLeft className='mr-2' />
            <p className="m-0">Kembali ke Beranda</p>
          </Link>
        </div>
        <div className="card terms-content">
          <div className="terms-title border-bottom">
            <p className="text-center fw-bold m-0">Syarat dan Ketentuan</p>
          </div>
          <div className="text-left py-4" style={{ fontSize: '0.75rem' }}>
            <p>Selamat datang di Market Auction Price (MAP).</p>
            <p>
              Syarat & ketentuan yang ditetapkan di bawah ini mengatur pemakaian jasa yang ditawarkan oleh PT Balai
              Lelang Serasi terkait transaksi dan penggunaan layanan di MAP serta situs map.ibid.astra.co.id . Pengguna
              disarankan membaca dengan seksama karena dapat berdampak kepada hak dan kewajiban Pengguna di bawah hukum.
              Dengan mendaftar dan/atau menggunakan situs map.ibid.astra.co.id , maka pengguna dianggap telah membaca,
              mengerti, memahami dan menyetujui semua isi dalam syarat & ketentuan. Syarat & ketentuan ini merupakan
              bentuk kesepakatan yang dituangkan dalam sebuah perjanjian yang sah antara Pengguna dengan PT Balai Lelang
              Serasi. Jika pengguna tidak menyetujui salah satu, sebagian, atau seluruh isi Syarat & ketentuan, maka
              pengguna tidak diperkenankan menggunakan layanan di Market Auction Price (MAP) melalui situs
              map.ibid.astra.co.id maupun aplikasi mobile MAP.
            </p>
            <p>
              <strong>PENDAFTARAN DAN MANAJEMEN AKUN</strong>
            </p>

            <ul>
              <li>
                Sebelum anda menggunakan layanan Market Auction Price (MAP), Anda wajib untuk melakukan pendaftaran
                melalui https://map.ibid.astra.co.id / yang dapat diakses melalui Ponsel atau Komputer Anda. Anda wajib
                untuk menyampaikan informasi yang benar, tepat dan terbaru dari diri Anda. Dengan melakukan pendaftaran,
                Anda menyetujui dan menerima Layanan Market Auction Price (MAP). Penerimaan tersebut berarti bahwa anda
                telah menerima seluruh Ketentuan dengan tanpa syarat dan tanpa adanya pengeculian dan oleh karenanya
                sepakat untuk terikat oleh Ketentuan termasuk setiap amandemen atau perubahan yang mungkin dibuat Market
                Auction Price (MAP) atas Ketentuan ini dikemudian hari.
              </li>
              <li>
                Untuk pendaftaran akun melalui link Market Auction Price (MAP), Anda akan menerima email yang berisi
                kata sandi dan detil informasi login lainnya untuk identifikasi diri Anda. Anda dilarang untuk
                mengungkapkan informasi login Anda kepada pihak ketiga manapun, kecuali apabila diperlukan berdasarkan
                hukum dan peraturan perundang-undangan yang berlaku (yang mana hal tersebut harus disampaikan kepada
                kami secara tertulis dengan segera). Anda setuju untuk menanggung setiap resiko terkait pengungkapan
                informasi login Anda kepada pihak ketiga manapun dan bertanggung jawab secara penuh atas setiap
                konsekuensi yang berkaitan dengan itu.
              </li>
              <li>
                Anda memahami dan setuju jika Anda menyajikan informasi yang tidak benar, tidak akurat, dan tidak sesuai
                dengan syarat dan ketentuan, maka kami berhak untuk menonaktifkan akun dan menolak untuk memberikan
                layanan kami.
              </li>
            </ul>
            <p>
              <strong>KETENTUAN PENGGUNAAN</strong>
            </p>

            <ul>
              <li>
                Anda dapat menggunakan Website & Aplikasi MAP sebelum melakukan pendaftaran namun akan memiliki
                keterbatasan dalam fitur – fitur yang disediakan oleh Market Auction Price (MAP)
              </li>
              <li>
                Anda dapat menggunakan Website & Aplikasi MAP lebih lengkap dengan fitur – fitur yang disediakan pada
                Website / Aplikasi MAP, setelah Anda berhasil mendaftarkan diri, Aplikasi akan memberikan Anda suatu
                akun pribadi yang dapat diakses dengan kata sandi yang kami email atau anda dapat merubah kata sandi
                sesuai dengan keinginan setelah menerima akun dari kami.
              </li>
              <li>
                Anda memahami dan setuju bahwa penggunaan Aplikasi oleh Anda akan tunduk pula pada Kebijakan Privasi
                kami sebagaimana dapat dirubah dari waktu ke waktu. Dengan menggunakan Aplikasi, Anda juga memberikan
                persetujuan sebagaimana dipersyaratkan berdasarkan Kebijakan Privasi kami.
              </li>
              <li>
                Mohon menginformasikan kepada kami jika Anda tidak lagi memiliki kontrol atas akun Anda, sebagai contoh
                akun Anda dengan cara bagaimanapun diretas (hack) atau telepon Anda dicuri, sehingga kami dapat
                membatalkan akun Anda dengan sebagaimana mestinya. Mohon diperhatikan bahwa Anda bertanggung jawab atas
                penggunaan akun Anda dan Anda mungkin dapat dimintakan tanggung jawabnya meskipun jika akun Anda
                tersebut disalahgunakan oleh orang lain.
              </li>
              <li>
                Sebagai langkah perkenalan terhadap Market Auction Price (MAP), kami menyediakan akun free trial dengan
                beberapa menu dan data yang kami batasi.
              </li>
              <li>Menu yang dapat diakses oleh akun trial meliputi menu Overview.</li>
              <li>Anda dapat mengakses semua menu ketika anda meng-upgrade akun premium.</li>
              <li>Kami akan memberikan notifikasi untuk mengingatkan masa berlaku akun Anda.</li>
              <li>Sistem kami akan secara otomatis memblokir akun anda ketika masa berlaku berakhir.</li>
            </ul>
            <p>
              <strong>SARANA DALAM BERTRANSAKSI DAN BERKOMUNIKASI</strong>
            </p>

            <p>
              Website ini adalah sarana yang disediakan untuk pelanggan agar dapat memperoleh informasi terkait layanan
              Market Auction Price (MAP) dan membagikan pengalamannya terkait Market Auction Price (MAP). Website ini
              tidak bisa dijadikan acuan dalam mengajukan opini maupun komplain di masa mendatang.
            </p>
            <p>
              <strong>HASIL DATA</strong>
            </p>

            <ul>
              <li>
                Data yang digunakan Market Auction Price (MAP) merupakan data hasil lelang dengan periode 1 – 6 bulan.
              </li>
              <li>
                Data unit yang terdapat pada Market Auction Price (MAP) merupakan data unit yang sudah dilakukan
                Inspeksi kendaraan Astra Car Valuation (ACV) yang dilakukan oleh inspektor kami yang independen, tidak
                terkait oleh penyedia jasa perbaikan kendaraan, penyedia jasa penjualan kendaraan, atau pihak kedua
                manapun.{' '}
              </li>
              <li>
                Grade yang tercantum pada Market Auction Price (MAP) merupakan hasil dari perhitungan sistem inspeksi
                Astra Car Valuation (ACV).
              </li>
              <li>
                Kami tidak memberikan jasa konsultasi terkait keperluan pelanggan dalam membeli atau menjual kendaraan.
                Lebih lanjut, kami tidak bertanggung jawab atas sah atau tidaknya hak penjual atau pembeli kendaraan
                dalam bertransaksi.
              </li>
              <li>
                Market Auction Price (MAP) tidak bertanggung jawab atas kerugian yang ditimbulkan baik secara langsung
                ataupun tidak langsung yang berhubungan dengan keputusan pembelian atau penjualan kendaraan. Jasa kami
                hanya bersifat membantu pelanggan untuk memahami harga dan kondisi kendaraan sebelum bertransaksi agar
                merasa tidak dirugikan di kemudian hari.
              </li>
              <li>
                Dilarang untuk menyalin, mengubah, mencetak, mengadaptasi, menerjemahkan, menciptakan karya tiruan,
                mendistribusikan, memberi lisensi, menjual, memindahkan, menampilkan (menunjukan) secara publik,
                menggandakan, mengirimkan, menyiarkan lewat media online mau pun offline, memotong, membongkar, atau
                sebaliknya mengeksploitasi bagian mana pun dari Market Auction Price (MAP), atau mencoba untuk menemukan
                kode sumber yang berkaitan dengan Layanan atau alat di dalamnya, dengan menggunakan robot atau perangkat
                otomatis baik itu proses atau sarana lainnya kecuali sejauh kegiatan tersebut secara tegas diizinkan
                oleh hukum yang berlaku walaupun ada pembatasan terkait hal ini.
              </li>
            </ul>
            <p>
              <strong>KELUHAN, KLAIM, DAN SENGKETA</strong>
            </p>

            <ul>
              <li>
                Penyampaian keluhan, klaim dan penyelesaian sengketa yang dilakukan ke MAP harus melalui Customer Center
                MAP (webchat MAP) dan disertai dengan bukti-bukti penunjang lainnya yang dapat menjadi dasar pembenar
                atas setiap argumen yang dikeluarkan oleh pihak penyampai keluhan, klaim dan penyelesaian sengketa.
              </li>
              <li>
                Keluhan, klaim dan penyelesaian sengketa yang diajukan ke pihak MAP hanya dapat dilakukan oleh pengguna
                yang sudah melakukan pendaftaran yang secara sah tercatat di MAP.
              </li>
              <li>
                Dalam penanganan keluhan, klaim dan penyelesaian sengketa setelah lelang, pihak MAP hanya akan
                berhubungan dengan Pemenang Lelang atau Perserta lelang yang secara sah tercatat di MAP. Pihak MAP
                berhak untuk tidak menanggapi keluhan, klaim dan sengketa setelah lelang dari pihak selain yang
                disebutkan sebelumnya.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <BottomNav history={history} />
    </div>
  );
};

export default TermsCondition;
